export default "__VITE_ASSET__81cef43b__"